import type { Database } from '@/lib/supabase/types.gen';

type RawUserRole = Database['public']['Enums']['user_role'];
export type UserRole = Exclude<RawUserRole, 'supervisor' | 'technician'>;

export const USER_ROLES = {
  administrator: 'administrator',
  tenant: 'tenant',
  manager: 'manager',
} as const satisfies Record<UserRole, UserRole>;

export type AppUser = {
  id: string;
  email: string | null;
  role: UserRole;
  tenantId: string | null;
  displayName: string | null;
};

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  administrator: 'Administrator',
  tenant: 'Tenant',
  manager: 'Manager',
};

export function userHasRole(
  user: AppUser | null | undefined,
  ...roles: readonly UserRole[]
): boolean {
  if (!user) {
    return false;
  }
  return roles.includes(user.role);
}
